<app-dynamic-banner
  *ngIf="showBanner"
  [title]="bannerTitle"
  [subtitle]="bannerDescription"
  [redirectUrl]="redirectBanner"
></app-dynamic-banner>
<app-modal-dynamic
  *ngIf="showModal"
  [title]="modalTitle"
  [message]="modalDescription"
  [actionLabel]="errorModalLabel"
  [show]="showModal"
  [closeButton]="cancelButton"
  (primaryAction)="onRequest()"
  (close)="closeErrorModal()"
></app-modal-dynamic>
<router-outlet> </router-outlet>
